(function(window) {
    'use strict'

    const internal = window.RTAnalyticsInternal

    function isReady(delivery) {
        if (!delivery.recipient || !delivery.recipient.counterId) {
            return false
        }

        if (delivery.action === 'ecommerce') {
            return true
        }

        return typeof window.ym === 'function'
    }

    function send(delivery) {
        const counterId = delivery.recipient.counterId
        const payload = delivery.payload || {}

        switch (delivery.action) {
            case 'goal':
                if (!payload.target) {
                    return false
                }
                window.ym(counterId, 'reachGoal', payload.target, payload.params)
                return true

            case 'hit':
                if (!payload.url) {
                    return false
                }
                window.ym(counterId, 'hit', payload.url, payload.options || {})
                return true

            case 'params':
                window.ym(counterId, 'params', payload.params || {})
                return true

            case 'userParams':
                window.ym(counterId, 'userParams', payload.params || {})
                return true

            case 'ecommerce':
                const dataLayerName = payload.dataLayerName || 'dataLayer'
                const dataLayer = window[dataLayerName] = window[dataLayerName] || []
                dataLayer.push(payload.command || {})
                return true

            default:
                return false
        }
    }

    internal.providers.register('yandexMetrika', {
        isReady: isReady,
        send: send
    })
})(window)
